/* eslint-disable react/jsx-props-no-spreading */
import Spoiler from "./Spoiler";

export function isLeaf(value): boolean {
  return typeof value === "object" && typeof value.text === "string";
}

const Leaf = ({ attributes, children, leaf, key }) => {
  let inner = children;
  if (leaf.spoiler) {
    inner = <Spoiler key={key}>{inner}</Spoiler>;
  }

  if (leaf.bold) {
    inner = <strong key={key}>{inner}</strong>;
  }

  if (leaf.code) {
    inner = <code key={key}>{inner}</code>;
  }

  if (leaf.italic) {
    inner = <em key={key}>{inner}</em>;
  }

  if (leaf.type === "br") {
    return <br />;
  }

  return (
    <span {...attributes} key={key}>
      {inner}
    </span>
  );
};
export default Leaf;
